import React from 'react'
import styled from 'styled-components'
import { Card } from '@ally/metronome-ui'

const StyledCard = styled(Card)`
  min-width: 320px;

  & > div {
    padding: 0;
  }
  @media print {
    break-inside: avoid;
    page-break-inside: avoid;
    position: relative;
  }
`

const WidgetWrapper: React.FC = ({ children }) => {
  return <StyledCard closeButton={false}>{children}</StyledCard>
}

export default WidgetWrapper
